<template>
<div name="subpage" v-if="data_unit!=null">

<div style="text-align: left;" >
  <el-button type="success" @click="$router.go(-1)">back</el-button>
</div>

<br>
<el-image 
  style="width: 100px; height: 100px; border-radius:15px;"
  :src="data_unit.folder+data_unit.imgs[0]"
></el-image>

<h1 class="white">{{data_unit.name}}</h1>

<h3 class="white">author: {{data_unit.client}}</h3>
<!-- <h4 class="white">{{data_unit.client}}</h4> -->

<h3 class="white">platfom: 
<!-- <h4 class="white"> -->
  <img
    v-for="(unit,index5) in platfoms"
    :key="index5"
    :src="unit"
    style="width:16px;height:16px;margin-right:5px;"
  /> 
<!-- </h4> -->
</h3>

<el-row
  :gutter="20"
  type="flex"
>
<el-col :span="10" v-for="(unit1,index3) in data_unit.imgs" :key="index3">
  <el-image lazy @click="onPreview(data_unit.folder+unit1)"
    style="max-height:200px; border-radius:15px;"
    :src="data_unit.folder+unit1"
  ></el-image>
</el-col>
</el-row>

<div v-show="data_unit.urls.length>0">
  <h3 class="white">link</h3>
  <h5 class="white">
    <a class="white" v-for="unit in data_unit.urls" :key="unit" :href="unit" target="_blank">{{unit}}</a>
  </h5>
</div>

<h3 class="white">website</h3>
<h5 class="white"><a class="white" :href="data_unit.website" target="_blank">{{data_unit.website}}</a></h5>

<div v-show="isPreview" class="preview" @click="onPreviewClose()">
  <img style="max-width:90%;max-height:90%;margin-top:10%;margin-bottom:10%;" v-show="previewImg!=null" :src="previewImg">
<!-- <el-row type="flex" justify="center">
  <el-col>
    <el-image :src="previewImg"></el-image>
  </el-col>
</el-row> -->
</div>

</div>
<div v-else>
</div>
</template>

<script>
import DataJson from "@/core/data.json";

export default {
  name:"SubPage",
  data(){
    return {
      data_unit:null,
      platfoms: [],
      previewImg:null,
      isPreview:false
    }
  },
  props:{
    type:String,
    name:String,
  },
  mounted:function(){
    // console.log([this.type, this.name]);
    var data = DataJson["data"][this.type];
    if(data){
      for (const key in data) {
        if(data[key].name==this.name){
          // console.log([this.name]);
          this.data_unit = data[key];
        }
      }
    }
    
    var pool_platfom = this.data_unit["platfom"];
    if (pool_platfom != null && pool_platfom.length > 0) {
      for (var i = 0; i < pool_platfom.length; i++) {
        switch (pool_platfom[i]) {
          case "ios":
          case "android":
          case "windows":
          case "mac":
          case "linux":
          case "other":
          case "web":
          case "wechat":
          case "wegame":
          case "weapp":
          case "unity":
          case "btc":
          case "godot":
          case "game_puzzle":
          case "manage":
          case "server":
          case "nodejs":
          case "vscode":
          case "greasymonkey":
          case "garmin":
          case "pebble":
            this.platfoms.push("./img/platfom/" + pool_platfom[i] + ".png");
        }
      }
      // console.log(this.platfoms);
      
    }
    
  },
  methods:{
    onPreview(v){
      this.isPreview = true;
      this.previewImg = v;
      // console.log(v);
    },
    onPreviewClose(){
      this.isPreview = false;
    },
  }
}
</script>

<style>
.white{
  color: #ffffff;
}
.preview{
  background-color: #00000088;
  width:100%;
  height:100%;
  position: absolute;
  left:0%;
  top:0%;
  /* vertical-align: middle; */
  text-align: center;
}
</style>
